import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
} from '../lib/permissions';
import { ADMIN_ROLES } from '../constants/system';

/**
 * Custom hook to check user permissions
 * @returns Object with permission checking functions and permissions array
 */
export const usePermissions = () => {
  const permissions = useSelector(
    (state: RootState) => state.auth.user?.permissions || []
  );
  const user = useSelector((state: RootState) => state.auth.user);

  const superAdmin = user?.role?.code === ADMIN_ROLES.superAdmin;

  const checkPermission = (permission: string): boolean => {
    return superAdmin || hasPermission(permissions, permission);
  };

  const checkAnyPermission = (requiredPermissions: string[]): boolean => {
    return superAdmin || hasAnyPermission(permissions, requiredPermissions);
  };

  const checkAllPermissions = (requiredPermissions: string[]): boolean => {
    return superAdmin || hasAllPermissions(permissions, requiredPermissions);
  };

  return {
    permissions,
    checkPermission,
    checkAnyPermission,
    checkAllPermissions,
    user,
  };
};
